export default __webpack_public_path__ + "static/media/IntersecDubai19_Events-Photo.17a310d9.jpg";